import React, {Component} from 'react';
import Radium from 'radium';
import Colors from '../utils/colors';

export class Bluebutton extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {

    };

  }

  componentDidMount() {

  }

  render() {

    return (

        <div style={styles.main} onClick={this.props.clickFunc}>
          {this.props.text}
        </div>
    );
  }

}

export default Radium(Bluebutton);

const styles = {
  main: {
    padding: 12,
    backgroundColor: Colors.mainBlue,
    color: "#ffffff",
    textAlign: 'center',
    borderRadius: 25,
    fontSize: 16,
    fontWeight: 'lighter',
    opacity: '0.8',
    textTransform: 'uppercase',
    width: '100%',
    ':hover': {
      cursor: 'pointer'
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/Bluebutton.js